import useLayerListeners from './useLayerListeners';
import mapValues from 'lodash/mapValues';
import omit from 'lodash/omit';
import { Ref, WatchStopHandle } from 'vue';
import { LAYER_CONFIG_OMIT_PROP } from '../constants';

export default function useMarkerLayer(mapInstance: LooseObject, layerInfo: Ref<MapLayer<MarkerLayerConfig>>) {
  if (!layerInfo.value || !layerInfo.value.config) return;

  const { id: layerId } = layerInfo.value;

  let markerStyle; let geometries;
  let unwatchList: WatchStopHandle[] | null = [];

  const markerLayer = new TMap.MultiMarker({
    id: layerId,
    map: mapInstance,
  });

  unwatchList.push(watch(() => omit(
    layerInfo.value.config,
    LAYER_CONFIG_OMIT_PROP,
  ), (newValue) => {
    const styleOption = mapValues(newValue, val => toRaw(unref(val)));
    if (!styleOption.src) delete styleOption.src; // 未传src时去掉，避免GL报错
    markerStyle = new TMap.MarkerStyle(styleOption);
    if (markerLayer) markerLayer.setStyles({ markerStyle });
  }, { deep: true, immediate: true }));

  unwatchList.push(watchEffect(() => {
    if (!Array.isArray(layerInfo.value.config.data)) return;
    try {
      geometries = layerInfo.value.config.data.map((geometry: MarkerGeometry, index: number) => {
        const { id, position, rank, properties, content } = geometry;
        return {
          id: id ? id : `${index}`,
          position: new TMap.LatLng(position.lat, position.lng, position.height),
          rank: rank ? rank : index,
          styleId: 'markerStyle',
          properties,
          content,
        };
      });
      if (markerLayer) markerLayer.setGeometries(geometries);
    } catch (error) {
      if (markerLayer) markerLayer.setGeometries([]);
    }
  }));

  // 用户传入的事件回调在这里处理
  unwatchList.push(watchEffect(() => {
    useLayerListeners(markerLayer, [
      { eventName: 'click', callbackList: layerInfo.value.config.onClick },
      { eventName: 'hover', callbackList: layerInfo.value.config.onHover },
    ]);
  }));

  markerLayer.unmount = (): void => {
    markerLayer?.destroy();
    unwatchList?.forEach(unwatch => unwatch());
    unwatchList = null;
  };

  return markerLayer;
}
